import SlideRight from './SlideRight'

export default SlideRight
